import { Dropdown } from "./dropdown";
import { LightDarkSwitcher } from "./lightDarkSwitcher";
import { UserMenu } from "./userMenu";

export class Home {
  static compiler() {
    // 下拉菜单
    Dropdown.compiler(".dropdown");

    // 主题切换
    LightDarkSwitcher.compiler("#theme-toggle");

    // 用户菜单
    UserMenu.compiler("[data-user-menu]");
  }
}
